// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"6f399425","354":"6f399425","524":"6f399425","676":"6f399425","824":"b54bed16"}[chunkId] + ".chunk.css";
};